import React, { Component } from "react";
import {
  Paper,
  MenuItem,
  AutoComplete,
  TextField,
  SelectField,
  RaisedButton,
} from "material-ui";

const dataSourceConfig = {
  text: "name",
  value: "id",
};

export default class ClientMailer extends Component {
  state = {
    month: "",
    mailing: "",
    dataSource: [],
    client: {},
  };

  getStyles() {
    return {
      button: {
        margin: 20,
      },
    };
  }

  render() {
    let { button } = this.getStyles();
    let { month, mailing, dataSource, client } = this.state;

    return (
      <Paper
        className="container"
        zDepth={2}
        style={{ marginTop: "2em", paddingTop: "1em", paddingBottom: "1em" }}
      >
        <h3>Client Mailer</h3>

        <AutoComplete
          onUpdateInput={this.handleSearch}
          floatingLabelText="Client"
          fullWidth={true}
          dataSource={dataSource}
          dataSourceConfig={dataSourceConfig}
          onNewRequest={this.handleClient}
        />
        <SelectField
          floatingLabelText="Mailing"
          fullWidth={true}
          onChange={this.handleMailingChange}
          value={mailing}
        >
          <MenuItem value="New Assessor" primaryText="New Assessor" />
          <MenuItem value="Assessor" primaryText="Assessor" />
          <MenuItem
            value="Year-End Engagement"
            primaryText="Year-End Engagement"
          />
          <MenuItem value="W2" primaryText="W2" />
          <MenuItem value="S-Corp Medical" primaryText="S-Corp Medical" />
        </SelectField>

        <SelectField
          floatingLabelText="Year End Month"
          fullWidth={true}
          onChange={this.handleMonthChange}
          value={month}
          disabled={true}
        >
          <MenuItem value="January" primaryText="January" />
          <MenuItem value="Febuary" primaryText="Febuary" />
          <MenuItem value="March" primaryText="March" />
          <MenuItem value="April" primaryText="April" />
          <MenuItem value="May" primaryText="May" />
          <MenuItem value="June" primaryText="June" />
          <MenuItem value="July" primaryText="July" />
          <MenuItem value="August" primaryText="August" />
          <MenuItem value="September" primaryText="September" />
          <MenuItem value="October" primaryText="October" />
          <MenuItem value="November" primaryText="November" />
          <MenuItem value="December" primaryText="December" />
        </SelectField>

        <RaisedButton
          label="Generate Single"
          style={button}
          onTouchTap={this.closeViewer}
          secondary={true}
        />
        <RaisedButton
          label="Generate Bulk"
          style={button}
          onTouchTap={this.closeViewer}
          secondary={true}
        />
      </Paper>
    );
  }

  handleSearch = (searchTerm) => {
    let url = "/clients/search";
    let options = {
      method: "POST",
      headers: {
        token: this.props.token.jwt,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ searchTerm }),
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        if (json.length > 0) {
          let clients = json.map((client) => {
            let name = `${client.name} | (${client.uid__c})`;
            return { id: client.id, name: name };
          });

          this.setState({ dataSource: clients });
        }
      });
  };

  handleClient = (chosen) => {
    this.setState({ client: chosen });
  };

  handleMonthChange = (e, i, val) => {
    this.setState({ month: val });
  };

  handleMailingChange = (e, i, val) => {
    this.setState({ mailing: val });
  };
}



// WEBPACK FOOTER //
// ./app/components/clients/ClientMailer.js